module.exports = __webpack_public_path__ + "img/image-3.ba2881c7.png";